<template>
  <form class="form" method="post">

    <div id="appClientChoiceVueComponent" class="appFontBlack">
      <HeaderApp />
      <div id="appClientCardCreate">
        <h2>Mes Clients ({{ client.length }})</h2>
        <div>
          <button @click.prevent="createClient()" type="submit" class="appButtonModel2">Créer un nouveau client</button>
        </div>
        <input type="text" v-model="search" class="appSearchBar" placeholder="Rechercher">

        <div :key="index" v-for="(client, index) in filteredClients" class="appClientCardList">
          <div class="appClientCardListLine1">
            <p>{{ client.firstname.toUpperCase() }} {{ client.lastname }}</p>
            <p>{{ client.sexe }} {{ format_date(client.birthdate) }}</p>
          </div>
          <div class="appClientCardListLine2">
            <p>{{ client.address.toLowerCase() }} {{ client.cp }} {{ client.city.toUpperCase() }}</p>
          </div>
          <div class="appClientCardListLine3">
            <a :href="`tel:${client.phone}`">{{ client.phone }}</a>
            <a :href="`mailto:${client.mail}`">{{ client.mail }}</a>
          </div>
          <br class="appClientCardListLine3">
          <button @click.prevent="editClient(client._id)" type="submit" class="appButtonModel3">Consulter / Modifier mon
            client </button>
        </div>
      </div>
    </div>

  </form>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import HeaderApp from '../Application/HeaderApp.vue'
export default {
  beforeCreate () {
    const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
    if (!tokenWithDatas) { this.$router.push('/App/Login') }
  },
  components: {
    HeaderApp
  },
  name: 'ClientsList',
  data () {
    return {
      client: '',
      search: ''
    }
  },
  computed: {
    filteredClients () {
      if (this.client.length > 0) {
        return this.client.filter(client => {
          return client.firstname.toLowerCase().includes(this.search.toLowerCase()) ||
          client.lastname.toLowerCase().includes(this.search.toLowerCase())
        })
      }
    }
  },
  mounted () {
    this.listClient()
  },
  methods: {
    format_date (value) {
      if (value) {
        return moment(String(value)).format('DD/MM/YYYY')
      }
    },
    listClient () {
      const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
      axios
        .get(('https://privilegia.fr/api/clients'), { headers: { Authorization: 'Bearer ' + tokenWithDatas.token } })
        .then((response) => {
          this.client = response.data.sort(function tri (a, b) {
            if (a.firstname < b.firstname) { return -1 }
            if (a.firstname === b.firstname) { return 0 }
            if (a.firstname > b.firstname) { return 1 }
          })
        })
    },
    createClient () {
      this.$router.push('/App/Clients/Create')
    },
    editClient (id) {
      this.$router.push('/App/Clients/Edit?id=' + id)
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Application/AppClientsChoice.vue